import Chosen from "../../../../modules/forms/Inputs/Select/Chosen";

const PhoneInput = {
    init() {
        this.el = $('[element].phoneInput');

        if (!this.el.length) {
            return;
        }

        this.countryInput = this.el.find("select#country");
        this.phoneInput = this.el.find("input#phone");

        this.countryNumber = this.el.find(".countryNumberPrefix");
        this.countryFlag = this.el.find(".countryFlag");

        Chosen.init(this.el);

        this.start();
        this.bind();
    },

    start() {

    },

    bind() {
        this.countryInput.on('change', PhoneInput.changeCountry);
        this.phoneInput.on('change', PhoneInput.phoneNumber);

        this.el
            .on('chosen:showing_dropdown', function () {
                let $_fooChosenResults = $('.chosen-results .active-result');

                $_fooChosenResults.each(function (index, el) {
                    let code = PhoneInput.countryInput.find("option:eq(" + $(el).data("option-array-index") + ")").attr("value");

                    if ($(this).find(".fi").length === 0) {
                        $(this).prepend('<div class="countryFlag"><span class="flag ' + code + '"></span></div>');
                    }
                });
            });
    },

    changeCountry() {
        let selectedOption = $(this).find("option:selected");
        let phonePrefix = selectedOption.data("prefix");

        PhoneInput.countryNumber.text(phonePrefix);
        PhoneInput.countryFlag.html('<span class="flag ' + selectedOption.attr("value") + '"></span>');

        PhoneInput.start();
        // console.log(selectedOption, phonePrefix);
    },

    phoneNumber() {
        $(this).val(PhoneInput.removeLeadingZeros($(this)));
    },

    removeLeadingZeros(input) {
        // Use a regular expression to remove leading zeros
        return input.val().replace(/^0+/, '');
    }
}
export default PhoneInput;